<template>
  <VcitaTextField
    :prefix="currencySymbol"
    type="number"
    v-bind="$attrs"
    v-on="$listeners"
    ref="priceField"
    step="0.01"
    min="0.01"
    max="999999"
    :value="Number(value)"
    class="price-input"
    @input="handlePriceInput"
    :label="$t('booking.info.price')">

  </VcitaTextField>
</template>

<script>
  import VcitaTextField from "@/modules/common/components/VcitaTextField/VcitaTextField.vue"

  export default {
    name: "PriceInput",
    components: {
      VcitaTextField,

    },
    props: {
      currencySymbol: {
        type: String,
        default: '',
      },
      value: {
        type: [Number, String],
        required: false,
      }
    },
    data() {
      return {
        previusValue: this.value || 0
      };
    },
    methods:{
      async handlePriceInput(val) {

        await this.$nextTick()
        let res;
        try {
          let modifiedVal = val.replace(/[^\d,.]/gmi, '')
          const numParts = modifiedVal.split(/[^\d]/gmi) //split by anything that isn't a number ie '.,' etc...
          const integerPart = numParts[0].substr(0,6)
          res = integerPart
          if(numParts[1]) {
            const decimalPart = numParts[1].substr(0,2)
            res += '.' + decimalPart
          }
          res = parseFloat(res).toString()
        } catch(e) {
          console.error(e)
          res = val
        }
        await this.$nextTick()
        if(parseFloat(this.previusValue) !== parseFloat(res)) {
          this.$refs.priceField.$el.querySelector('input').value = res
          this.$emit('input', res)
          this.previusValue = parseFloat(res)
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import url('https://fonts.googleapis.com/css2?family=Gothic+A1:wght@500&family=Montserrat&display=swap');
  .price-input {
    ::v-deep {
      .v-text-field__prefix {
        font-family: Gothic A1;
        font-weight: 600;
      }
    }

  }
</style>
